import { WishAndExpectation, WishSettings, WishesFieldType } from '../../../ana-toolbox'

const feelingOptions = [
  {
    label: 'option.rating.label.feeling.very_dissatisfied',
    value: '1',
  },
  {
    label: 'option.rating.label.feeling.dissatisfied',
    value: '2',
  },
  {
    label: 'option.rating.label.feeling.somewhat_dissatisfied',
    value: '3',
  },
  {
    label: 'option.rating.label.feeling.satisfied',
    value: '4',
  },
  {
    label: 'option.rating.label.feeling.very_satisfied',
    value: '5',
  },
]

const frequencyOptions = [
  {
    label: 'option.rating.label.frequency.never',
    value: '1',
  },
  {
    label: 'option.rating.label.frequency.rarely',
    value: '2',
  },
  {
    label: 'option.rating.label.frequency.sometimes',
    value: '3',
  },
  {
    label: 'option.rating.label.frequency.often',
    value: '4',
  },
  {
    label: 'option.rating.label.frequency.very_often',
    value: '5',
  },
]

const importantOptions = [
  {
    label: 'option.rating.label.important.functional',
    value: '2',
  },
  {
    label: 'option.rating.label.important.aesthetic',
    value: '3',
  },
  {
    label: 'option.rating.label.important.premium',
    value: '4',
  },
  {
    label: 'option.rating.label.important.noAnswer',
    value: '1',
  },
]

const booleanOptions = [
  {
    label: 'yes',
    value: 'true',
  },
  {
    label: 'no',
    value: 'false',
  },
]

const wishBooleanRatingFactory = (key: string, value: string) => ({ key, flag: value === 'true' })

const wishNumberRatingFactory = (key: string, value: string) => ({ key, score: Number(value) })

export const wishesSettings: Record<string, WishSettings> = {
  has_toothache: {
    type: WishesFieldType.RATING,
    ratingOptions: frequencyOptions,
    wishFactory: wishNumberRatingFactory,
  },

  satisfied_tooth_color: {
    type: WishesFieldType.RATING,
    ratingOptions: feelingOptions,
    wishFactory: wishNumberRatingFactory,
  },

  satisfied_tooth_position: {
    type: WishesFieldType.RATING,
    ratingOptions: feelingOptions,
    wishFactory: wishNumberRatingFactory,
  },

  satisfied_filling_color: {
    type: WishesFieldType.RATING,
    ratingOptions: booleanOptions,
    updateDependantWishes: (wish: WishAndExpectation, wishes: WishAndExpectation[]): WishAndExpectation[] => {
      if (wish.flag === true) {
        return wishes.filter((w) => w.key !== 'informed_ceramic_inlays')
      }

      return wishes
    },
    wishFactory: wishBooleanRatingFactory,
  },

  what_is_important: {
    type: WishesFieldType.RATING,
    ratingOptions: importantOptions,
    wishFactory: wishNumberRatingFactory,
    required: true,
  },

  informed_ceramic_inlays: {
    type: WishesFieldType.RATING,
    ratingOptions: booleanOptions,
    visibleWhen: (wishes: WishAndExpectation[]) =>
      wishes?.some((w) => w.key === 'satisfied_filling_color' && w.flag === false) || false,
    wishFactory: wishBooleanRatingFactory,
  },

  has_bridges: {
    type: WishesFieldType.RATING,
    ratingOptions: booleanOptions,
    updateDependantWishes: (_wish: WishAndExpectation, wishes: WishAndExpectation[]): WishAndExpectation[] => {
      return wishes
    },
    wishFactory: wishBooleanRatingFactory,
  },
}
